import React, { useEffect, useState } from "react";

import SocialMedia from "components/About/SocialMedia";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import DiscussMaria from "components/Insights/DiscussMaria";
import HeroInsight from "components/Insights/HeroInsight";
import ListInsight from "components/Insights/ListInsight";
import MissionInsight from "components/Insights/MissionInsight";
import { useLocation } from "react-router-dom";

export const Insight = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");

      setTimeout(() => {
        const element = document.getElementById(id);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, [location]);
  return (
    <div>
      <MissionInsight />
      <div id="insight">
        <ListInsight />
      </div>
      <DiscussMaria />
    </div>
  );
};
